<template>
  <div class="resultTemp">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.resultTemp {
  max-width: 1172px;
  min-height: 520px;
  margin: auto;
  // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.14);
  overflow: hidden;
  padding: 0 14px;
}
</style>